import React, { useContext } from 'react'
import classes from './WhyDMPImportant.module.css'
import { ThemeContext } from '../../App'



interface WhyDMPImportantkProps {
  whyImportant: {
    mainTitle: string,
    imgSrc1Dark: string,
    imgSrc1Light: string,
    title1: string,
    desc1: string,
    imgSrc2Dark: string,
    imgSrc2Light: string,
    title2: string,
    desc2: string,
    imgSrc3Dark: string,
    imgSrc3Light: string,
    title3: string,
    desc3: string
  }
}

const WhyDMPImportant: React.FC<WhyDMPImportantkProps> = ({
  whyImportant: { mainTitle, imgSrc1Dark, imgSrc1Light, title1, desc1, imgSrc2Dark, imgSrc2Light, title2, desc2, imgSrc3Dark, imgSrc3Light, title3, desc3 }, }) => {

  const { theme } = useContext(ThemeContext)

  return (
    <div id={classes[theme]} className={classes.container + ' pt-vh30-top md:pt-vh40-top'}>
      <h2 className='text-center w-vw90 mx-auto text-smBtwPages md:text-mdBtwPages lg:text-lgBtwPages mb-bottom-vh15'>Why is a <strong className='font-normal'>{mainTitle} Partner important?</strong></h2>

      <div className='flex flex-col lg:flex-row w-vw90 mx-auto items-start'>
        <div className='flex flex-col items-center mb-bottom-vh10 lg:mb-0'>
          <img src={theme === "dark" ? imgSrc1Dark : imgSrc1Light} className='w-vw10 lg:w-vw3 mb-bottom-vh1 lg:mb-bottom-vh1' />
          <h4 className='text-smTitlesForH md:text-mdTitlesForH lg:text-lgSepBtnTxt mb-bottom-vh3 w-4/5 text-center'>{title1}</h4>
          <p className='text-center text-smSepBtnTxt md:text-mdAddTxt lg:text-lgAddTxt w-4/5'>{desc1}</p>
        </div>
        <div className='flex flex-col items-center mb-bottom-vh10 lg:mb-0'>
          <img src={theme === "dark" ? imgSrc2Dark : imgSrc2Light} className='w-vw10 lg:w-vw3 mb-bottom-vh1 lg:mb-bottom-vh1' />
          <h4 className='text-smTitlesForH md:text-mdTitlesForH lg:text-lgSepBtnTxt mb-bottom-vh3 w-4/5 text-center'>{title2}</h4>
          <p className='text-center text-smSepBtnTxt md:text-mdAddTxt lg:text-lgAddTxt w-4/5'>{desc2}</p>
        </div>
        <div className='flex flex-col items-center mb-bottom-vh10 lg:mb-0'>
          <img src={theme === "dark" ? imgSrc3Dark : imgSrc3Light} className='w-vw10 lg:w-vw3 mb-bottom-vh1 lg:mb-bottom-vh1' />
          <h4 className='text-smTitlesForH md:text-mdTitlesForH lg:text-lgSepBtnTxt mb-bottom-vh3 w-4/5 text-center'>{title3}</h4>
          <p className='text-center text-smSepBtnTxt md:text-mdAddTxt lg:text-lgAddTxt w-4/5'>{desc3}</p>
        </div>
      </div>
    </div>
  )
}

export default WhyDMPImportant;
